<script setup>
// Cinematic shimmer placeholder for a payment method stamp while loading.
</script>

<template>
  <div class="road">
    <span class="road__dot" />
    <div class="road__lines">
      <span class="road__line road__line--wide" />
      <span class="road__line road__line--narrow" />
    </div>
  </div>
</template>

<style scoped>
@keyframes stamp-pulse {
  0%, 100% { opacity: 0.35; }
  50%       { opacity: 0.65; }
}

.road {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-3) var(--sp-4);
  border-radius: var(--r-md);
  border: 1px solid var(--ash);
  background: var(--bg-glass);
  animation: stamp-pulse 1.6s var(--ease-cinema) infinite;
}

.road__dot {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--ash-strong);
}

.road__lines {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.road__line {
  display: block;
  height: 10px;
  border-radius: var(--r-xs);
  background: var(--ash);
}

.road__line--wide   { width: 55%; }
.road__line--narrow { width: 30%; }
</style>
